// =========================================================
// ANIMATIONS — constantes partagées (GSAP)
// Durations / easings / staggers centralisés pour cohérence
// visuelle et ajustement global trivial.
// =========================================================

export const ANIM = {
    ease: {
        out:     "power3.out",
        outSoft: "power2.out",
        spring:  "back.out(1.4)",
        scale:   "expo.out",
    },
    duration: {
        xs: 0.45, sm: 0.6, md: 0.8, lg: 1.0, xl: 1.2,
    },
    start: {
        large:   "top 75%",
        section: "top 85%",
        items:   "top 90%",
    },
    stagger: {
        tight: 0.06,
        std:   0.08,
        loose: 0.12,
    },
    overlap: {
        sm: 0.35, md: 0.5, lg: 0.65,
    },
    yOffset: {
        sm: 18, md: 32, lg: 50,
    },
};

export const PRESETS = {
    fadeUp:   { opacity: 0, y: ANIM.yOffset.md },
    fadeUpSm: { opacity: 0, y: ANIM.yOffset.sm },
    fadeUpLg: { opacity: 0, y: ANIM.yOffset.lg },
    fadeIn:   { opacity: 0 },
    scaleIn:  { opacity: 0, scale: 0.96 },
};
